export function createChartSeries(data = [], name = '', seriesOptions = {}) {
  return {
    data: sortChartSeries(data),
    name: name || '',
    type: 'line',
    ...seriesOptions,
  }
}

function sortChartSeries(serie) {
  if (!serie || !Array.isArray(serie)) {
    return []
  }

  return serie
    .map((item) => ({ x: Date.parse(item.x), y: item.y }))
    .sort((a, b) => a.x - b.x)
}
